/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `Resource Types`
};

const fr_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `Types de ressources`
};

const de_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `Ressourcentypen`
};

const es_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `Tipos de recursos`
};

const it_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `Tipi di risorse`
};

const ar_resource_type_label17 = /** @type {(inputs: {}) => string} */ () => {
	return `أنواع الموارد`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const resource_type_label17 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.resource_type_label17(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("resource_type_label17", locale)
	if (locale === "en") return en_resource_type_label17(inputs)
	if (locale === "fr") return fr_resource_type_label17(inputs)
	if (locale === "de") return de_resource_type_label17(inputs)
	if (locale === "es") return es_resource_type_label17(inputs)
	if (locale === "it") return it_resource_type_label17(inputs)
	return ar_resource_type_label17(inputs)
};
export { resource_type_label17 as "RESOURCE_TYPE_LABEL" }